import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '@pg-app/core/services/roles/role.guard';
import { RoleNames } from '@pg-app/core/services/roles/RoleNames';
import { CommissionReportComponent } from './commission-report.component';

const routes: Routes = [
  {
    path: '',
    component: CommissionReportComponent,
    canActivate: [RoleGuard],
    data: {
      expectedRole: RoleNames.VIEW_REPORT,
      redirectUrl: '/partner/search-referral'
    }
  }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class CommissionReportRoutingModule { }
